//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import BackendServices from "@/services/backend-services.js";
import Table from "@/components/FilterTable/Table";
import ScheduleTable from "@/pages/StoreManagement/components/ScheduleTable.vue";

const DEFAULT_FORMAT = value => (value ? value : "N/A");

const TABLE_LIST_COLUMNS = [
  {
    name: "code",
    required: false,
    label: "Código",
    align: "right",
    field: row => row.code,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "name",
    required: false,
    align: "left",
    label: "Nome de loja",
    field: row => row.name,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "external-code",
    required: false,
    align: "left",
    label: "ID Externo",
    field: (row) => row.external_id,
    format: DEFAULT_FORMAT,
    sortable: false,
  },
  {
    name: "retalhista",
    required: false,
    align: "left",
    label: "Retalhista",
    field: row => row.hierarchy[0].name,
    sortable: false
  },
  {
    name: "insignia",
    required: false,
    align: "left",
    label: "Insignia",
    field: row => (row.hierarchy[1] ? row.hierarchy[1].name : null),
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "cadeia",
    required: false,
    align: "left",
    label: "Cadeia",
    field: row => (row.hierarchy[2] ? row.hierarchy[2].name : null),
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "store-typology",
    required: false,
    align: "left",
    label: "Tipologia de loja",
    field: (row) => row.store_typology,
    format: DEFAULT_FORMAT,
    sortable: false,
  },
  {
    name: "nipc",
    required: false,
    align: "left",
    label: "NIPC",
    field: row => row.nipc,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "contact",
    required: false,
    align: "left",
    label: "Telefone",
    field: row => row.contact,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "management",
    required: false,
    align: "left",
    label: "Pessoa responsável",
    field: row => row.management,
    format: DEFAULT_FORMAT,
    sortable: false
  },
  {
    name: "schedule",
    required: false,
    align: "left",
    label: "Horário",
    field: row => row.schedule,
    sortable: false,
    icon: {
      conditional: false,
      content: {
        name: "schedule",
        color: "blue-10",
        customComponent: ScheduleTable,
        customComponentProps: {
          data: "value"
        }
      }
    }
  },
  {
    name: "market-type",
    required: false,
    align: "left",
    label: "Mercado",
    format: DEFAULT_FORMAT,
    field: row => row.market_type.name,
    sortable: false
  },
  {
    name: "store-channel",
    required: false,
    align: "left",
    label: "Canal",
    format: DEFAULT_FORMAT,
    field: row => row.channel.name,
    sortable: false
  },
  // {
  //   name: "new-code",
  //   align: "left",
  //   label: "Novo código",
  //   field: "new-code",
  //   sortable: false,
  // },
  {
    name: "storage-facility",
    required: false,
    align: "left",
    label: "Armazém",
    format: DEFAULT_FORMAT,
    field: row => row.storage_facility,
    sortable: false
  }
];

export default {
  name: "TraitsTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table
  },
  data: () => ({
    separator: "horizontal",
    pagination: {
      rowsPerPage: 10 // current rows per page being displayed
    },
    columns: TABLE_LIST_COLUMNS
  }),
  methods: {
    updateSearch(search) {
      this.$emit("search-changed", search);
    },
    renderRightSide: function (event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    }
  }
};
